"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseRelatedMetaTables () {
        return BaseRelatedMetaTables;
    },
    get CACHE_PREFIX () {
        return CACHE_PREFIX;
    },
    get CacheDelDirection () {
        return CacheDelDirection;
    },
    get CacheGetType () {
        return CacheGetType;
    },
    get CacheScope () {
        return CacheScope;
    },
    get DB_TYPES () {
        return DB_TYPES;
    },
    get FilterCacheScope () {
        return FilterCacheScope;
    },
    get MetaTable () {
        return MetaTable;
    },
    get MetaTableOldV2 () {
        return MetaTableOldV2;
    },
    get NC_STORE_DEFAULT_WORKSPACE_ID_KEY () {
        return NC_STORE_DEFAULT_WORKSPACE_ID_KEY;
    },
    get PrincipalType () {
        return PrincipalType;
    },
    get ResourceType () {
        return ResourceType;
    },
    get RootScopeTables () {
        return RootScopeTables;
    },
    get RootScopes () {
        return RootScopes;
    },
    get orderedMetaTables () {
        return orderedMetaTables;
    },
    get sakilaTableNames () {
        return sakilaTableNames;
    }
});
var MetaTable = /*#__PURE__*/ function(MetaTable) {
    MetaTable["PROJECT"] = "nc_bases_v2";
    MetaTable["SOURCES"] = "nc_sources_v2";
    MetaTable["SOURCES_OLD"] = "nc_sources_v2";
    MetaTable["MODELS"] = "nc_models_v2";
    MetaTable["COLUMNS"] = "nc_columns_v2";
    MetaTable["COLUMN_VALIDATIONS"] = "nc_columns_validations_v2";
    MetaTable["COL_PROPS"] = "nc_col_props_v2";
    MetaTable["COL_RELATIONS"] = "nc_col_relations_v2";
    MetaTable["COL_SELECT_OPTIONS"] = "nc_col_select_options_v2";
    MetaTable["COL_LOOKUP"] = "nc_col_lookup_v2";
    MetaTable["COL_ROLLUP"] = "nc_col_rollup_v2";
    MetaTable["COL_FORMULA"] = "nc_col_formula_v2";
    MetaTable["COL_QRCODE"] = "nc_col_qrcode_v2";
    MetaTable["COL_BARCODE"] = "nc_col_barcode_v2";
    MetaTable["COL_LONG_TEXT"] = "nc_col_long_text_v2";
    MetaTable["FILTER_EXP"] = "nc_filter_exp_v2";
    // HOOK_FILTER_EXP = 'nc_hook_filter_exp_v2',
    MetaTable["SORT"] = "nc_sort_v2";
    MetaTable["SHARED_VIEWS"] = "nc_shared_views_v2";
    MetaTable["ACL"] = "nc_acl_v2";
    MetaTable["FORM_VIEW"] = "nc_form_view_v2";
    MetaTable["FORM_VIEW_COLUMNS"] = "nc_form_view_columns_v2";
    MetaTable["GALLERY_VIEW"] = "nc_gallery_view_v2";
    MetaTable["GALLERY_VIEW_COLUMNS"] = "nc_gallery_view_columns_v2";
    MetaTable["CALENDAR_VIEW"] = "nc_calendar_view_v2";
    MetaTable["CALENDAR_VIEW_COLUMNS"] = "nc_calendar_view_columns_v2";
    MetaTable["CALENDAR_VIEW_RANGE"] = "nc_calendar_view_range_v2";
    MetaTable["GRID_VIEW"] = "nc_grid_view_v2";
    MetaTable["GRID_VIEW_COLUMNS"] = "nc_grid_view_columns_v2";
    MetaTable["KANBAN_VIEW"] = "nc_kanban_view_v2";
    MetaTable["KANBAN_VIEW_COLUMNS"] = "nc_kanban_view_columns_v2";
    MetaTable["USERS"] = "nc_users_v2";
    MetaTable["ORGS_OLD"] = "nc_orgs_v2";
    MetaTable["TEAMS_OLD"] = "nc_teams_v2";
    MetaTable["TEAM_USERS_OLD"] = "nc_team_users_v2";
    MetaTable["VIEWS"] = "nc_views_v2";
    MetaTable["AUDIT"] = "nc_audit_v2";
    MetaTable["HOOKS"] = "nc_hooks_v2";
    MetaTable["HOOK_LOGS"] = "nc_hook_logs_v2";
    MetaTable["HOOK_TRIGGER_FIELDS"] = "nc_hook_trigger_fields";
    MetaTable["PLUGIN"] = "nc_plugins_v2";
    MetaTable["PROJECT_USERS"] = "nc_base_users_v2";
    MetaTable["MODEL_ROLE_VISIBILITY"] = "nc_disabled_models_for_role_v2";
    MetaTable["API_TOKENS"] = "nc_api_tokens";
    MetaTable["SYNC_SOURCE"] = "nc_sync_source_v2";
    MetaTable["SYNC_LOGS"] = "nc_sync_logs_v2";
    MetaTable["MAP_VIEW"] = "nc_map_view_v2";
    MetaTable["MAP_VIEW_COLUMNS"] = "nc_map_view_columns_v2";
    MetaTable["LIST_VIEW"] = "nc_list_view_v2";
    MetaTable["LIST_VIEW_COLUMNS"] = "nc_list_view_columns_v2";
    MetaTable["LIST_VIEW_LEVELS"] = "nc_list_view_levels_v2";
    MetaTable["STORE"] = "nc_store";
    MetaTable["NOTIFICATION"] = "notification";
    MetaTable["USER_REFRESH_TOKENS"] = "nc_user_refresh_tokens";
    MetaTable["EXTENSIONS"] = "nc_extensions";
    MetaTable["COMMENTS"] = "nc_comments";
    MetaTable["USER_COMMENTS_NOTIFICATIONS_PREFERENCE"] = "nc_user_comment_notifications_preference";
    MetaTable["COMMENTS_REACTIONS"] = "nc_comment_reactions";
    MetaTable["JOBS"] = "nc_jobs";
    MetaTable["INTEGRATIONS"] = "nc_integrations_v2";
    MetaTable["INTEGRATIONS_STORE"] = "nc_integrations_store_v2";
    MetaTable["FILE_REFERENCES"] = "nc_file_references";
    MetaTable["COL_BUTTON"] = "nc_col_button_v2";
    MetaTable["SNAPSHOT"] = "nc_snapshots";
    MetaTable["ROW_COLOR_CONDITIONS"] = "nc_row_color_conditions";
    MetaTable["DATA_REFLECTION"] = "nc_data_reflection";
    MetaTable["CUSTOM_URLS"] = "nc_custom_urls_v2";
    MetaTable["SYNC_CONFIGS"] = "nc_sync_configs";
    MetaTable["SYNC_MAPPINGS"] = "nc_sync_mappings";
    MetaTable["USAGE_STATS"] = "nc_usage_stats";
    MetaTable["MCP_TOKENS"] = "nc_mcp_tokens";
    MetaTable["DB_SERVERS"] = "nc_db_servers";
    MetaTable["TEAMS"] = "nc_teams";
    MetaTable["TEAM_USERS"] = "nc_team_users";
    MetaTable["PERMISSIONS"] = "nc_permissions";
    MetaTable["PERMISSION_SUBJECTS"] = "nc_permission_subjects";
    MetaTable["PRINCIPALS"] = "nc_principals";
    MetaTable["PRINCIPAL_ASSIGNMENTS"] = "nc_principal_assignments";
    MetaTable["DASHBOARDS"] = "nc_dashboards_v2";
    MetaTable["WIDGETS"] = "nc_widgets_v2";
    MetaTable["OAUTH_CLIENTS"] = "nc_oauth_clients";
    MetaTable["OAUTH_AUTHORIZATION_CODES"] = "nc_oauth_authorization_codes";
    MetaTable["OAUTH_TOKENS"] = "nc_oauth_tokens";
    MetaTable["LAYOUT"] = "nc_ds_layout_v2";
    MetaTable["WIDGET"] = "nc_ds_widget_v2";
    MetaTable["DASHBOARD_PROJECT_DB_PROJECT_LINKINGS"] = "nc_ds_dashboard_project_db_project_linkings_v2";
    MetaTable["WIDGET_DB_DEPENDENCIES"] = "nc_ds_widget_db_dependencies_v2";
    MetaTable["BOOK"] = "nc_books";
    MetaTable["WORKSPACE"] = "workspace";
    MetaTable["WORKSPACE_USER"] = "workspace_user";
    MetaTable["FOLLOWER"] = "nc_follower";
    MetaTable["COWRITER"] = "cowriter";
    MetaTable["MODEL_STAT"] = "nc_model_stats_v2";
    MetaTable["DB_MUX"] = "nc_sql_executor_v2";
    MetaTable["SSO_CLIENT"] = "nc_sso_client";
    MetaTable["SSO_CLIENT_DOMAIN"] = "nc_sso_client_domain";
    MetaTable["ORG_DOMAIN"] = "nc_org_domain";
    MetaTable["ORG"] = "nc_org";
    MetaTable["ORG_USERS"] = "nc_org_users";
    MetaTable["PLANS"] = "nc_plans";
    MetaTable["SUBSCRIPTIONS"] = "nc_subscriptions";
    MetaTable["AUTOMATIONS"] = "nc_automations";
    MetaTable["AUTOMATION_EXECUTIONS"] = "nc_automation_executions";
    MetaTable["DEPENDENCY_TRACKER"] = "nc_dependency_tracker";
    MetaTable["INSTALLATIONS"] = "nc_installations";
    MetaTable["SANDBOXES_OLD"] = "nc_sandboxes";
    MetaTable["SANDBOX_VERSIONS_OLD"] = "nc_sandbox_versions";
    MetaTable["SANDBOX_DEPLOYMENT_LOGS_OLD"] = "nc_sandbox_deployment_logs";
    MetaTable["MANAGED_APPS"] = "nc_managed_apps";
    MetaTable["MANAGED_APP_VERSIONS"] = "nc_managed_app_versions";
    MetaTable["MANAGED_APP_DEPLOYMENT_LOGS"] = "nc_managed_app_deployment_logs";
    MetaTable["AUTOMATION_SUBSCRIBERS"] = "nc_automation_subscribers";
    MetaTable["SANDBOXES"] = "nc_sandboxes_v2";
    MetaTable["SCIM_CONFIG"] = "nc_scim_config";
    MetaTable["RECORD_TEMPLATES"] = "nc_record_templates";
    MetaTable["RLS_POLICIES"] = "nc_rls_policies";
    MetaTable["RLS_POLICY_SUBJECTS"] = "nc_rls_policy_subjects";
    MetaTable["VIEW_SECTIONS"] = "nc_view_sections";
    return MetaTable;
}({});
const BaseRelatedMetaTables = [
    "nc_calendar_view_columns_v2",
    "nc_calendar_view_range_v2",
    "nc_calendar_view_v2",
    "nc_col_barcode_v2",
    "nc_col_button_v2",
    "nc_col_formula_v2",
    "nc_col_long_text_v2",
    "nc_col_lookup_v2",
    "nc_col_qrcode_v2",
    "nc_col_relations_v2",
    "nc_col_rollup_v2",
    "nc_col_select_options_v2",
    "nc_columns_v2",
    "nc_comment_reactions",
    "nc_comments",
    "nc_custom_urls_v2",
    "nc_dashboards_v2",
    "nc_disabled_models_for_role_v2",
    "nc_extensions",
    "nc_filter_exp_v2",
    "nc_form_view_columns_v2",
    "nc_form_view_v2",
    "nc_gallery_view_columns_v2",
    "nc_gallery_view_v2",
    "nc_grid_view_columns_v2",
    "nc_grid_view_v2",
    "nc_hook_logs_v2",
    "nc_hooks_v2",
    "nc_kanban_view_columns_v2",
    "nc_kanban_view_v2",
    "nc_map_view_columns_v2",
    "nc_map_view_v2",
    "nc_list_view_columns_v2",
    "nc_list_view_levels_v2",
    "nc_list_view_v2",
    "nc_mcp_tokens",
    "nc_models_v2",
    "nc_permissions",
    "nc_permission_subjects",
    "nc_rls_policies",
    "nc_rls_policy_subjects",
    "nc_row_color_conditions",
    "nc_sort_v2",
    "nc_sources_v2",
    "nc_sync_configs",
    "nc_sync_logs_v2",
    "nc_sync_mappings",
    "nc_sync_source_v2",
    "nc_views_v2",
    "nc_widgets_v2",
    "nc_model_stats_v2",
    "nc_automations",
    "nc_automation_executions",
    "nc_dependency_tracker"
];
var MetaTableOldV2 = /*#__PURE__*/ function(MetaTableOldV2) {
    MetaTableOldV2["PROJECT"] = "nc_projects_v2";
    MetaTableOldV2["PROJECT_USERS"] = "nc_project_users_v2";
    MetaTableOldV2["BASES"] = "nc_bases_v2";
    MetaTableOldV2["LAYOUT"] = "nc_ds_layout_v2";
    MetaTableOldV2["WIDGET"] = "nc_ds_widget_v2";
    MetaTableOldV2["DASHBOARD_PROJECT_DB_PROJECT_LINKINGS"] = "nc_ds_dashboard_project_db_project_linkings_v2";
    MetaTableOldV2["WIDGET_DB_DEPENDENCIES"] = "nc_ds_widget_db_dependencies_v2";
    MetaTableOldV2["WORKFLOWS"] = "nc_workflows";
    MetaTableOldV2["WORKFLOW_EXECUTIONS"] = "nc_workflow_executions";
    MetaTableOldV2["SCRIPTS"] = "nc_scripts";
    MetaTableOldV2["OUTLINE_VIEW"] = "nc_outline_view_v2";
    MetaTableOldV2["OUTLINE_VIEW_COLUMNS"] = "nc_outline_view_columns_v2";
    MetaTableOldV2["OUTLINE_VIEW_LEVELS"] = "nc_outline_view_levels_v2";
    return MetaTableOldV2;
}({});
const orderedMetaTables = [
    "nc_disabled_models_for_role_v2",
    "nc_plugins_v2",
    "nc_audit_v2",
    "nc_teams",
    "nc_principal_assignments",
    "nc_orgs_v2",
    "nc_base_users_v2",
    "nc_users_v2",
    "nc_map_view_v2",
    "nc_map_view_columns_v2",
    "nc_list_view_v2",
    "nc_list_view_columns_v2",
    "nc_list_view_levels_v2",
    "nc_kanban_view_columns_v2",
    "nc_kanban_view_v2",
    "nc_calendar_view_v2",
    "nc_calendar_view_columns_v2",
    "nc_calendar_view_range_v2",
    "nc_grid_view_columns_v2",
    "nc_grid_view_v2",
    "nc_gallery_view_columns_v2",
    "nc_gallery_view_v2",
    "nc_form_view_columns_v2",
    "nc_form_view_v2",
    "nc_shared_views_v2",
    "nc_sort_v2",
    "nc_filter_exp_v2",
    "nc_hook_logs_v2",
    "nc_hooks_v2",
    "nc_hook_trigger_fields",
    "nc_views_v2",
    "nc_col_formula_v2",
    "nc_col_rollup_v2",
    "nc_col_lookup_v2",
    "nc_col_select_options_v2",
    "nc_col_relations_v2",
    "nc_columns_validations_v2",
    "nc_columns_v2",
    "nc_record_templates",
    "nc_models_v2",
    "nc_sources_v2",
    "nc_bases_v2"
];
const sakilaTableNames = [
    'actor',
    'address',
    'category',
    'city',
    'country',
    'customer',
    'film',
    'film_actor',
    'film_category',
    'film_text',
    'inventory',
    'language',
    'payment',
    'rental',
    'staff',
    'store',
    'actor_info',
    'customer_list',
    'film_list',
    'nicer_but_slower_film_list',
    'sales_by_film_category',
    'sales_by_store',
    'staff_list'
];
var CacheScope = /*#__PURE__*/ function(CacheScope) {
    CacheScope["PROJECT"] = "base";
    CacheScope["SOURCE"] = "source";
    CacheScope["MODEL"] = "model";
    CacheScope["COLUMN"] = "column";
    CacheScope["COL_PROP"] = "colProp";
    CacheScope["COL_RELATION"] = "colRelation";
    CacheScope["COL_SELECT_OPTION"] = "colSelectOption";
    CacheScope["COL_LOOKUP"] = "colLookup";
    CacheScope["COL_ROLLUP"] = "colRollup";
    CacheScope["COL_FORMULA"] = "colFormula";
    CacheScope["COL_QRCODE"] = "colQRCode";
    CacheScope["COL_BARCODE"] = "colBarcode";
    CacheScope["COL_LONG_TEXT"] = "colLongText";
    CacheScope["FILTER_EXP"] = "filterExp";
    CacheScope["SORT"] = "sort";
    CacheScope["SHARED_VIEW"] = "sharedView";
    CacheScope["ACL"] = "acl";
    CacheScope["FORM_VIEW"] = "formView";
    CacheScope["FORM_VIEW_COLUMN"] = "formViewColumn";
    CacheScope["GALLERY_VIEW"] = "galleryView";
    CacheScope["GALLERY_VIEW_COLUMN"] = "galleryViewColumn";
    CacheScope["GRID_VIEW"] = "gridView";
    CacheScope["GRID_VIEW_COLUMN"] = "gridViewColumn";
    CacheScope["KANBAN_VIEW"] = "kanbanView";
    CacheScope["CALENDAR_VIEW"] = "calendarView";
    CacheScope["CALENDAR_VIEW_COLUMN"] = "calendarViewColumn";
    CacheScope["CALENDAR_VIEW_RANGE"] = "calendarViewRange";
    CacheScope["MAP_VIEW"] = "mapView";
    CacheScope["MAP_VIEW_COLUMN"] = "mapViewColumn";
    CacheScope["KANBAN_VIEW_COLUMN"] = "kanbanViewColumn";
    CacheScope["LIST_VIEW"] = "listView";
    CacheScope["LIST_VIEW_COLUMN"] = "listViewColumn";
    CacheScope["LIST_VIEW_LEVEL"] = "listViewLevel";
    CacheScope["USER"] = "user";
    CacheScope["ORGS_OLD"] = "orgs";
    CacheScope["TEAM"] = "team";
    CacheScope["TEAM_USER"] = "teamUser";
    CacheScope["VIEW"] = "view";
    CacheScope["AUDIT"] = "audit";
    CacheScope["HOOK"] = "hook";
    CacheScope["PLUGIN"] = "plugin";
    CacheScope["BASE_USER"] = "baseUser";
    CacheScope["MODEL_ROLE_VISIBILITY"] = "modelRoleVisibility";
    CacheScope["API_TOKEN"] = "apiToken";
    CacheScope["INSTANCE_META"] = "instanceMeta";
    CacheScope["USER_BASE"] = "userBase";
    CacheScope["DASHBOARD_PROJECT_DB_PROJECT_LINKING"] = "dashboardProjectDBProjectLinking";
    CacheScope["SINGLE_QUERY"] = "singleQuery";
    CacheScope["JOBS"] = "nc_jobs";
    CacheScope["JOBS_POLLING"] = "nc_jobs_polling";
    CacheScope["PRESIGNED_URL"] = "presignedUrl";
    CacheScope["STORE"] = "store";
    CacheScope["PROJECT_ALIAS"] = "baseAlias";
    CacheScope["MODEL_ALIAS"] = "modelAlias";
    CacheScope["VIEW_ALIAS"] = "viewAlias";
    CacheScope["SSO_CLIENT"] = "ssoClient";
    CacheScope["EXTENSION"] = "uiExtension";
    CacheScope["INTEGRATION"] = "integration";
    CacheScope["COL_BUTTON"] = "colButton";
    CacheScope["CMD_PALETTE"] = "cmdPalette";
    CacheScope["PRODUCT_FEED"] = "productFeed";
    CacheScope["SNAPSHOT"] = "snapshot";
    CacheScope["DATA_REFLECTION"] = "dataReflection";
    CacheScope["CUSTOM_URLS"] = "customUrls";
    CacheScope["SCRIPTS"] = "nc_scripts";
    CacheScope["SYNC_CONFIGS"] = "syncConfigs";
    CacheScope["SYNC_MAPPINGS"] = "syncMappings";
    CacheScope["USAGE_STATS"] = "usageStats";
    CacheScope["RESOURCE_STATS"] = "resourceStats";
    CacheScope["STORAGE_STATS"] = "storageStats";
    CacheScope["CLOUD_FEATURES"] = "cloudFeatures";
    CacheScope["MCP_TOKEN"] = "mcpToken";
    CacheScope["DB_SERVERS"] = "dbServers";
    CacheScope["PERMISSION"] = "permission";
    CacheScope["PERMISSION_USER"] = "permissionUser";
    CacheScope["PRINCIPAL"] = "principal";
    CacheScope["PRINCIPAL_ASSIGNMENT"] = "principalAssignment";
    CacheScope["DASHBOARD"] = "dashboard";
    CacheScope["WIDGET"] = "widget";
    CacheScope["OAUTH_CLIENT"] = "oAuthClient";
    CacheScope["OAUTH_AUTH_CODE"] = "oAuthAuthCode";
    CacheScope["OAUTH_TOKEN"] = "oAuthToken";
    CacheScope["TEMPLATES"] = "templates";
    CacheScope["WORKFLOW"] = "nc_workflow";
    CacheScope["WORKFLOW_EXECUTION"] = "nc_workflow_execution";
    CacheScope["WORKFLOW_WEBHOOK_TEST_LISTENER"] = "nc_workflow_webhook_test_listener";
    CacheScope["DEPENDENCY_TRACKER"] = "nc_dependency_tracker";
    CacheScope["INSTALLATION"] = "installation";
    CacheScope["INSTALLATION_ALIAS"] = "installationAlias";
    CacheScope["MANAGED_APP"] = "managedApp";
    CacheScope["MANAGED_APP_VERSION"] = "managedAppVersion";
    CacheScope["MANAGED_APP_DEPLOYMENT_LOG"] = "managedAppDeploymentLog";
    CacheScope["SUBSCRIPTIONS_ALIAS"] = "subscriptionsAlias";
    CacheScope["AUTOMATION_SUBSCRIBER"] = "automationSubscriber";
    CacheScope["SANDBOX"] = "sandbox";
    CacheScope["SCIM_CONFIG"] = "scimConfig";
    CacheScope["RECORD_TEMPLATE"] = "recordTemplate";
    CacheScope["RLS_POLICY"] = "rlsPolicy";
    CacheScope["VIEW_SECTION"] = "viewSection";
    return CacheScope;
}({});
var CacheGetType = /*#__PURE__*/ function(CacheGetType) {
    CacheGetType["TYPE_ARRAY"] = "TYPE_ARRAY";
    CacheGetType["TYPE_OBJECT"] = "TYPE_OBJECT";
    CacheGetType["TYPE_STRING"] = "TYPE_STRING";
    return CacheGetType;
}({});
var CacheDelDirection = /*#__PURE__*/ function(CacheDelDirection) {
    CacheDelDirection["PARENT_TO_CHILD"] = "PARENT_TO_CHILD";
    CacheDelDirection["CHILD_TO_PARENT"] = "CHILD_TO_PARENT";
    return CacheDelDirection;
}({});
const DB_TYPES = [
    'mysql2',
    'sqlite3',
    'mysql',
    'snowflake',
    'oracledb',
    'pg',
    'databricks'
];
var RootScopes = /*#__PURE__*/ function(RootScopes) {
    RootScopes["ROOT"] = "root";
    RootScopes["ORG"] = "org";
    RootScopes["WORKSPACE"] = "workspace";
    RootScopes["BASE"] = "base";
    // This scope only used for extract-ids middleware to get initial entity
    RootScopes["BYPASS"] = "bypass";
    // BYPASS only meant for v2 bases now, we will use FULL_BYPASS for other full bypass scenarios like shared base/view (get with uuid)
    RootScopes["FULL_BYPASS"] = "full_bypass";
    return RootScopes;
}({});
const RootScopeTables = {
    ["root"]: [
        "nc_users_v2",
        "nc_user_refresh_tokens",
        "nc_api_tokens",
        "nc_follower",
        "nc_plugins_v2",
        "nc_sql_executor_v2",
        "nc_store",
        "notification",
        "nc_jobs",
        "nc_file_references",
        "nc_data_reflection",
        "nc_managed_apps",
        "nc_managed_app_versions",
        "nc_managed_app_deployment_logs",
        "nc_sandboxes_v2",
        "nc_audit_v2",
        "nc_custom_urls_v2",
        "nc_mcp_tokens",
        "nc_teams"
    ],
    ["org"]: [
        "nc_org",
        "nc_org_domain",
        "nc_org_users",
        "nc_sso_client",
        "nc_sso_client_domain"
    ],
    ["workspace"]: [
        "workspace",
        "workspace_user",
        "nc_integrations_v2",
        "nc_sources_v2",
        "nc_col_button_v2",
        "nc_col_long_text_v2",
        "nc_principal_assignments",
        "nc_scim_config"
    ],
    ["base"]: [
        "nc_bases_v2"
    ]
};
const CACHE_PREFIX = process.env.NC_CACHE_PREFIX && process.env.NC_CACHE_PREFIX.trim().length > 0 ? process.env.NC_CACHE_PREFIX : 'nc';
var FilterCacheScope = /*#__PURE__*/ function(FilterCacheScope) {
    FilterCacheScope["VIEW"] = "view";
    FilterCacheScope["HOOK"] = "hook";
    FilterCacheScope["COLUMN"] = "column";
    FilterCacheScope["PARENT_COLUMN"] = "parentColumn";
    FilterCacheScope["LINK_COL"] = "linkCol";
    FilterCacheScope["WIDGET"] = "widget";
    FilterCacheScope["PARENT"] = "parent";
    FilterCacheScope["RLS_POLICY"] = "rlsPolicy";
    FilterCacheScope["BUTTON_COLUMN"] = "buttonColumn";
    return FilterCacheScope;
}({});
const NC_STORE_DEFAULT_WORKSPACE_ID_KEY = 'NC_DEFAULT_WORKSPACE_ID';
var ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["ORG"] = "org";
    ResourceType["WORKSPACE"] = "workspace";
    ResourceType["BASE"] = "base";
    ResourceType["TEAM"] = "team";
    return ResourceType;
}({});
var PrincipalType = /*#__PURE__*/ function(PrincipalType) {
    PrincipalType["USER"] = "user";
    PrincipalType["TEAM"] = "team";
    PrincipalType["BOT"] = "bot";
    PrincipalType["GROUP"] = "group";
    PrincipalType["SERVICE"] = "service";
    return PrincipalType;
}({});
